import React, { Fragment, useEffect, useContext, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import AddIcon from "../../images/add.svg";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddIntelliFiberUserRoles from "./AddIntelliFiberUserRoles";
import AuthContext from "../../context/auth/AuthContext";
import ProjectContext from "../../context/project/ProjectContext";
import { Assignments } from "../../types/project";
import AlertDialog from "./popupDialogue";

function IntelliFiberRolesConfiguration() {
  const authContext = useContext(AuthContext);
  let { user } = authContext;
  const {
    // selectedProject,
    intelliFiberUserRoles,
    roles,
    users,
    loading,
    // getProjectAssignmentsV2,
  } = useContext(ProjectContext);

  const [showTable, setShowTable] = useState(false);
  //   const [projAssign, setProjAssign] = useState<Assignments[]>([]);
  const [openAddRoles, setOpenAddRoles] = React.useState(false);
  const [localAssignments, setLocalAssignments] = React.useState<Assignments[]>(
    []
  );

  const getUserRoleType = () => {
    //check User's Role
    if (intelliFiberUserRoles && intelliFiberUserRoles.length > 0) {
      console.log("$$$USER :", user);
      const role = intelliFiberUserRoles.find(
        (item) => item.UserID === user?.userID
      );
      console.log("$$$USER Role:", role);
      if (role) {
        return role.RoleName ? role.RoleName : "";
      }
    }
    return "";
  };

  //   const fetchProjectAssignments = async () => {
  //     if (getProjectAssignmentsV2 && selectedProject) {
  //       try {
  //         console.log(
  //           `Calling User Assignments from RoleCOnfig for ${selectedProject.ID}`
  //         );
  //         const projectAssignments = await getProjectAssignmentsV2(
  //           selectedProject.ID
  //         );
  //         console.log("@@Project Assignments:", projectAssignments);
  //         if (projectAssignments && projectAssignments.length > 0)
  //           setProjAssign(projectAssignments);
  //       } catch (error) {
  //         console.log("@@Error:", error);
  //       }
  //     }
  //   };

  const handleShowAddRoles = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    // navigate("/new-unit");
    setOpenAddRoles(true);
  };

  const handleAddRolesClose = () => {
    setOpenAddRoles(false);
  };

  useEffect(() => {
    if (intelliFiberUserRoles && intelliFiberUserRoles.length > 0) {
      setShowTable(true);
      setLocalAssignments(intelliFiberUserRoles);
      console.log(
        "Checking for assignments: ",
        JSON.stringify(intelliFiberUserRoles)
      );
    } else {
      setShowTable(false);
    }
  }, [intelliFiberUserRoles]);

  useEffect(() => {
    // console.log(`Project list updated V2: ${JSON.stringify(selectedProject)}`);
    // fetchProjectAssignments();
    console.log(
      `Project assignments: ${JSON.stringify(intelliFiberUserRoles)}`
    );
    console.log(`Project roles: ${JSON.stringify(roles)}`);
    console.log(`Project users: ${JSON.stringify(users)}`);
  }, []);

  return (
    <Fragment>
      {openAddRoles && (
        <AddIntelliFiberUserRoles
          showDialog={openAddRoles}
          handleClose={handleAddRolesClose}
        />
      )}
      <Grid container>
        <Grid container sx={{ margin: 2, px: 2, minWidth: "50vh" }}>
          <Button
            sx={{ p: 1, mx: 2, maxHeight: "50px" }}
            onClick={handleShowAddRoles}
            color='secondary'
            variant='contained'
            disabled={getUserRoleType() !== "Central GIS Team"}
          >
            <img
              src={AddIcon}
              alt='Add Project Role'
              className='nav-bar__menu__button_icon'
            />
            Add Roles
          </Button>
        </Grid>
      </Grid>
      {showTable ? (
        <Grid container className='center-pane' sx={{ mx: 2, px: 2 }}>
          <TableContainer
            component={Paper}
            sx={{
              mx: 2,
              px: 2,
              minHeight: "60vh",
              overflowY: "scroll",
            }}
          >
            <Table aria-label='role table'>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontSize: "large" }} align='center'>
                    Role
                  </TableCell>
                  <TableCell sx={{ fontSize: "large" }} align='center'>
                    User Id
                  </TableCell>
                  <TableCell sx={{ fontSize: "large" }} align='center'>
                    User Name
                  </TableCell>
                  <TableCell sx={{ fontSize: "large" }} align='center'>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!localAssignments
                  ? null
                  : localAssignments.map((item) => (
                      // <Fragment>
                      <TableRow key={item.OBJECTID}>
                        {/* <Fragment> */}
                        <TableCell align='center'>{item.RoleName}</TableCell>
                        <TableCell align='center'>{item.UserID}</TableCell>
                        <TableCell align='center'>{item.UserName}</TableCell>
                        <TableCell align='center'>
                          {getUserRoleType() === "Central GIS Team" && (
                            <AlertDialog deleteId={item.OBJECTID} />
                          )}
                        </TableCell>
                        {/* </Fragment> */}
                      </TableRow>
                      // </Fragment>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      ) : (
        <Grid
          container
          className='center-pane'
          justifyContent='center'
          sx={{ mx: 2, px: 2 }}
        >
          <div style={{ textAlign: "center", fontWeight: "bold" }}>
            {loading ? "Loading...Please wait!" : "No Records Found"}
          </div>
        </Grid>
      )}

      <Grid
        container
        display='flex'
        flexDirection='row'
        justifyContent='flex-end'
        alignContent='flex-end'
        width='100%'
      >
        <Box
          display='flex'
          flexDirection='row'
          justifyContent='flex-end'
          sx={{ height: "50px" }}
        ></Box>
      </Grid>
    </Fragment>
  );
}

export default IntelliFiberRolesConfiguration;
